<template>

    <div>

           <!--搜索页面-->
    </div>
</template>


<script>
    export default{

        data () {
            return {
                    msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Search.vue